// src/lib/render/markdown-bold.ts
//
// **bold** for the ACT passage surface. Science passages label each side of
// a conflicting-viewpoints set, and each study, in bold ("**Scientist 1**",
// "**Study 2**") — 415 live passages. The labels carry meaning (the questions
// say "According to Scientist 2…"), so StemRenderer shows them in bold when a
// caller opts in (markdownBold) instead of printing the asterisks.
//
// Bold ONLY, deliberately. A single "*" in a passage is far more often a
// footnote mark or a multiplication than emphasis, and the SAT stem surface
// (which shares StemRenderer) does not opt in at all. Same flanking rule as
// RichText's parser: the span opens on a non-space and closes after one, and
// never crosses a line, so "2 ** 3" or a stray "**" stays literal text.

export type BoldSegment = { bold: boolean; text: string }

const BOLD_RE = /\*\*(?=\S)([^*\n]*?\S)\*\*/g

export function splitMarkdownBold(text: string): BoldSegment[] {
  if (!text.includes('**')) return [{ bold: false, text }]
  const out: BoldSegment[] = []
  let last = 0
  BOLD_RE.lastIndex = 0
  for (let m = BOLD_RE.exec(text); m; m = BOLD_RE.exec(text)) {
    if (m.index > last) out.push({ bold: false, text: text.slice(last, m.index) })
    out.push({ bold: true, text: m[1] })
    last = m.index + m[0].length
  }
  if (last < text.length) out.push({ bold: false, text: text.slice(last) })
  return out
}
